import createTheme from '@signal/theme/createTheme'
import light from './light'
/* if-not-on-site-start */
import dark from './dark'
/* if-not-on-site-end */

export const makeLightTheme = () => createTheme(light)
/* if-not-on-site-start */
export const makeDarkTheme = () => createTheme(dark)
/* if-not-on-site-end */

export default makeLightTheme
